/**
 * YD Global CTA JS
 * - 文案轮播 (GSAP opacity 动画)
 * - 弹窗展开/收起动画
 * - 产品轮播图
 * - Variant 选择联动
 * - 加购物车 (Shopify Ajax Cart API)
 * - FAQ 手风琴
 */
(function() {
  'use strict';

  /**
   * 初始化 CTA 文案轮播
   */
  function initCTATextRotation() {
    const cta = document.getElementById('global-cta');
    if (!cta) return;

    const configData = cta.dataset.config;
    if (!configData) return;

    const config = JSON.parse(configData);
    const texts = config.texts || [];
    const interval = config.interval || 10000;

    const validTexts = texts.filter(t => t && t.trim());
    if (validTexts.length === 0) return;

    let currentIndex = 0;
    const textElement = cta.querySelector('.cta-default p');
    if (!textElement) return;

    let rotationTimer = null;

    function rotateText() {
      if (typeof gsap === 'undefined') return;

      gsap.to(textElement, {
        opacity: 0,
        duration: 0.3,
        ease: 'power2.out',
        onComplete: function() {
          currentIndex = (currentIndex + 1) % validTexts.length;
          textElement.textContent = validTexts[currentIndex];
          gsap.to(textElement, {
            opacity: 1,
            duration: 0.3,
            ease: 'power2.in'
          });
        }
      });
    }

    rotationTimer = setInterval(rotateText, interval);

    var ctaSection = cta.closest('.shopify-section');
    if (ctaSection) {
      ctaSection.addEventListener('shopify:section:unload', function() {
        if (rotationTimer) {
          clearInterval(rotationTimer);
          rotationTimer = null;
        }
        gsap.killTweensOf(textElement);
      });
    }
  }

  /**
   * 初始化 CTA 弹窗交互
   */
  function initCTAModal() {
    const cta = document.getElementById('global-cta');
    const orderBtn = cta?.querySelector('.cta-button');
    const closeBtn = cta?.querySelector('.cta-modal-close');
    const overlay = document.getElementById('cta-overlay');

    if (!cta || !orderBtn || !closeBtn || !overlay) return;

    let initialWidth = 0;
    let initialHeight = 0;
    let scrollY = 0;

    orderBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      expandModal();
    });

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      collapseModal();
    });

    overlay.addEventListener('click', () => {
      collapseModal();
    });

    // 挂在 document 上的监听随 section 卸载移除（主题编辑器重载时不叠加）
    const docListeners = new AbortController();
    cta.closest('.shopify-section')?.addEventListener('shopify:section:unload', () => docListeners.abort(), { once: true });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && cta.classList.contains('expanded')) {
        collapseModal();
      }
    }, { signal: docListeners.signal });

    function lockScroll() {
      // 优先用 Lenis 的 stop 锁滚，避免 position:fixed hack 与 Lenis 内部 scroll 不一致
      if (window.YDLenis && window.YDLenis.isReady) {
        window.YDLenis.stop();
        // 同时阻止原生滚轮/触摸事件渗透到页面
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
      } else {
        scrollY = window.scrollY;
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = -scrollY + 'px';
        document.body.style.width = '100%';
      }
    }

    function unlockScroll() {
      if (window.YDLenis && window.YDLenis.isReady) {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        window.YDLenis.start();
      } else {
        document.documentElement.style.overflow = '';
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.width = '';
        window.scrollTo(0, scrollY);
      }
    }

    var modalTl = null;

    function expandModal() {
      if (modalTl) modalTl.kill();
      if (typeof gsap === 'undefined') return;

      var rect = cta.getBoundingClientRect();
      initialWidth = rect.width;
      initialHeight = rect.height;

      var targetWidth = Math.min(1560, window.innerWidth * 0.95);
      // 高度策略与 CSS 保持一致：矮屏 (<800px) 用 80vh，否则 85vh，封顶 960
      var vhRatio = window.innerHeight < 800 ? 0.80 : 0.85;
      var targetHeight = Math.min(960, window.innerHeight * vhRatio);

      overlay.classList.remove('yd-hidden');
      lockScroll();
      ppActivate();

      // 直接用 gsap.set 设初始尺寸，不依赖 offsetHeight 强制重排
      gsap.set(cta, { width: initialWidth, height: initialHeight });

      modalTl = gsap.timeline({
        defaults: { ease: 'power2.inOut' },
        onStart: function() {
          cta.classList.add('expanding');
        }
      });

      modalTl
        .to(overlay, { autoAlpha: 1, duration: 0.3 }, 0)
        .to(cta, { width: targetWidth, duration: 0.3 }, 0)
        .to(cta, {
          height: targetHeight,
          borderRadius: 16,
          duration: 0.3,
          onComplete: function() {
            cta.classList.add('expanded');
          }
        }, 0.25);
    }

    function collapseModal() {
      if (modalTl) modalTl.kill();
      if (typeof gsap === 'undefined') return;

      cta.classList.remove('expanded');

      modalTl = gsap.timeline({
        defaults: { ease: 'power2.inOut' },
        onComplete: function() {
          cta.classList.remove('expanding');
          gsap.set(cta, { clearProps: 'width,height,borderRadius' });
          overlay.classList.add('yd-hidden');
          unlockScroll();
        }
      });

      modalTl
        .to(overlay, { autoAlpha: 0, duration: 0.3 }, 0)
        .to(cta, { height: initialHeight, duration: 0.3 }, 0)
        .to(cta, { width: initialWidth, duration: 0.3 }, 0.2);
    }

    // 暴露 collapseModal 供 addToCart 成功后调用
    cta._collapseModal = collapseModal;
  }

  /**
   * 初始化产品轮播图
   * 图片集跟随所选 variant：slide 上的 data-variants / data-featured-for / data-shared
   * 由 liquid 按「变体图片」与「alt 含选项值」两条规则生成（见 section 注释）。
   * 返回 { setVariant(variantId) } 供 variant 卡片联动调用。
   */
  var galleryApi = null;

  function initGallery() {
    var gallery = document.querySelector('.modal-product-gallery');
    if (!gallery) return null;

    var allSlides = Array.from(gallery.querySelectorAll('.gallery-slide'));
    var prevBtn = gallery.querySelector('.gallery-prev');
    var nextBtn = gallery.querySelector('.gallery-next');

    var slides = allSlides.slice();   // 当前 variant 可见的 slide 集合（有序）
    var currentIndex = 0;
    var totalSlides = slides.length;
    var isAnimating = false;
    var currentVariantId = null;

    // 自动轮播：仅弹窗展开时运行；用户操作后重置 timer；hover 暂停
    var AUTOPLAY_INTERVAL = 4000;
    var autoplayTimer = null;
    var cta = document.getElementById('global-cta');

    function autoplayTick() {
      if (cta && cta.classList.contains('expanded') && !document.hidden) {
        goToSlide(currentIndex + 1);
      }
    }
    function startAutoplay() {
      stopAutoplay();
      if (totalSlides <= 1) return;
      autoplayTimer = setInterval(autoplayTick, AUTOPLAY_INTERVAL);
    }
    function stopAutoplay() {
      if (autoplayTimer) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }
    function restartAutoplay() {
      if (cta && cta.classList.contains('expanded')) startAutoplay();
    }

    // 监听弹窗开关：展开启动，收起停止
    if (cta) {
      var ctaClassObserver = new MutationObserver(function() {
        if (cta.classList.contains('expanded')) startAutoplay();
        else stopAutoplay();
      });
      ctaClassObserver.observe(cta, { attributes: true, attributeFilter: ['class'] });
    }

    // 鼠标悬停暂停
    gallery.addEventListener('mouseenter', stopAutoplay);
    gallery.addEventListener('mouseleave', restartAutoplay);

    function tokens(el, attr) {
      var v = el.getAttribute(attr) || '';
      return v.split(/\s+/).filter(Boolean);
    }

    /**
     * 计算某 variant 的图片集：变体图片 → 该 variant 的其它专属图 → 通用图。
     * 该 variant 一张专属图都没有时，退化为「全部图片」（与旧行为一致，不至于空白）。
     */
    function slidesForVariant(variantId) {
      var id = String(variantId || '');
      if (!id) return allSlides.slice();
      var featured = [], specific = [], shared = [];
      allSlides.forEach(function(slide) {
        var vs = tokens(slide, 'data-variants');
        var fs = tokens(slide, 'data-featured-for');
        if (fs.indexOf(id) !== -1) featured.push(slide);
        else if (vs.indexOf(id) !== -1) specific.push(slide);
        else if (slide.hasAttribute('data-shared')) shared.push(slide);
      });
      var list = featured.concat(specific, shared);
      return list.length ? list : allSlides.slice();
    }

    function showOnly(slide) {
      allSlides.forEach(function(el) {
        var on = el === slide;
        el.classList.toggle('active', on);
        if (typeof gsap !== 'undefined') gsap.set(el, { autoAlpha: on ? 1 : 0 });
      });
    }

    function updateNav() {
      var show = totalSlides > 1;
      if (prevBtn) prevBtn.style.display = show ? '' : 'none';
      if (nextBtn) nextBtn.style.display = show ? '' : 'none';
    }

    /**
     * 切换到某 variant 的图片集，回到第一张（变体图片）。幂等：同一 variant 重复调用不重置。
     */
    function setVariant(variantId) {
      var id = String(variantId || '');
      if (id && id === currentVariantId) return;
      currentVariantId = id;
      if (typeof gsap !== 'undefined') gsap.killTweensOf(allSlides);
      isAnimating = false;
      slides = slidesForVariant(id);
      totalSlides = slides.length;
      currentIndex = 0;
      showOnly(slides[0]);
      updateNav();
      restartAutoplay();
    }

    // 初始状态：显示第一张（variant 卡片初始化时会再按默认选中项 setVariant）
    showOnly(slides[0]);
    updateNav();

    function goToSlide(index) {
      if (isAnimating || index === currentIndex || totalSlides <= 1) return;
      if (index < 0) index = totalSlides - 1;
      if (index >= totalSlides) index = 0;

      if (typeof gsap === 'undefined') {
        // 降级：无 GSAP 时用 class 切换
        slides.forEach(function(slide, i) { slide.classList.toggle('active', i === index); });
        currentIndex = index;
        return;
      }

      isAnimating = true;

      // kill 之前可能残留的 tween
      gsap.killTweensOf(slides);

      gsap.to(slides[currentIndex], {
        autoAlpha: 0,
        duration: 0.4,
        ease: 'power2.inOut'
      });

      gsap.to(slides[index], {
        autoAlpha: 1,
        duration: 0.4,
        ease: 'power2.inOut',
        onComplete: function() { isAnimating = false; }
      });

      currentIndex = index;
    }

    prevBtn?.addEventListener('click', function() { goToSlide(currentIndex - 1); restartAutoplay(); });
    nextBtn?.addEventListener('click', function() { goToSlide(currentIndex + 1); restartAutoplay(); });

    // ===== 触摸/鼠标横向滑动切换 =====
    // 使用 pointer events，覆盖 touch / mouse / pen
    // 阈值：水平位移 > 50px 且明显大于垂直位移（避免误触竖向滚动）
    var SWIPE_THRESHOLD = 50;
    var startX = 0;
    var startY = 0;
    var isPointerDown = false;
    var isHorizontalSwipe = false;

    gallery.addEventListener('pointerdown', function(e) {
      // 忽略来自前后按钮的 pointer（避免重复触发）
      if (e.target.closest('.gallery-prev, .gallery-next')) return;
      isPointerDown = true;
      isHorizontalSwipe = false;
      startX = e.clientX;
      startY = e.clientY;
    });

    gallery.addEventListener('pointermove', function(e) {
      if (!isPointerDown) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      // 首次判定方向后锁定（避免水平/垂直来回切换）
      if (!isHorizontalSwipe && Math.abs(dx) > 10 && Math.abs(dx) > Math.abs(dy)) {
        isHorizontalSwipe = true;
      }
      // 水平滑动时阻止默认（防止图片被浏览器拖拽 / 父级横向滚动）
      if (isHorizontalSwipe) {
        e.preventDefault();
      }
    });

    function endSwipe(e) {
      if (!isPointerDown) return;
      var dx = e.clientX - startX;
      var dy = e.clientY - startY;
      isPointerDown = false;

      // 仅当水平位移占主导且超过阈值时切换
      if (Math.abs(dx) >= SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
        if (dx < 0) {
          goToSlide(currentIndex + 1);   // 左滑 → 下一张
        } else {
          goToSlide(currentIndex - 1);   // 右滑 → 上一张
        }
        restartAutoplay();
      }
      isHorizontalSwipe = false;
    }

    gallery.addEventListener('pointerup', endSwipe);
    gallery.addEventListener('pointercancel', endSwipe);
    // 图片本身可能被浏览器识别为可拖拽元素，禁用以免干扰滑动
    gallery.querySelectorAll('img').forEach(function(img) {
      img.setAttribute('draggable', 'false');
    });

    galleryApi = { setVariant: setVariant };
    return galleryApi;
  }

  /**
   * 初始化右侧滚动提示
   * 监听 modal-right-scroll 滚动，到底时隐藏渐变遮罩
   */
  function initScrollFade() {
    const scrollContainer = document.querySelector('[data-scroll-container]');
    const scrollFade = document.querySelector('[data-scroll-fade]');
    if (!scrollContainer || !scrollFade) return;

    function checkScroll() {
      var atBottom = scrollContainer.scrollHeight - scrollContainer.scrollTop - scrollContainer.clientHeight < 10;
      scrollFade.classList.toggle('is-hidden', atBottom);
    }

    // 初始检查
    checkScroll();

    scrollContainer.addEventListener('scroll', checkScroll, { passive: true });

    // 弹窗展开后重新检查（内容高度可能变化）
    var observer = new MutationObserver(checkScroll);
    observer.observe(scrollContainer, { childList: true, subtree: true });
  }

  /**
   * 初始化 Variant 选择卡片
   * 点击卡片切换选中（每个 variant 固定加 1 件，数量在购物车页调整）
   * 选中卡片高亮，至少 1 个卡片选中时按钮 enabled
   */
  /**
   * PayPal Pay Later 分期文案（Figma 4331:344「paypal-info-bar」）
   * 文案本体（PayPal logo / "Starting at $X/mo or as low as 0% APR." / Learn more）
   * 全部由官方 paypal.Messages 渲染，金额与期数由 PayPal 计算；
   * 外层容器与分割线见 sections/yd-global-cta.liquid 的 .modal-paypal-bar。
   */
  const PP_SIZE_MOBILE = 10;   // Figma 移动端稿字号
  const PP_SIZE_DESKTOP = 12;  // 桌面弹窗价格/按钮更大，同比放大一档
  const ppState = { sdk: null, amount: null, size: null };

  function ppBar() {
    return document.querySelector('[data-paypal-bar]');
  }

  function ppMessageSize() {
    return window.matchMedia('(max-width: 1023.98px)').matches ? PP_SIZE_MOBILE : PP_SIZE_DESKTOP;
  }

  function ppLoadSdk() {
    if (ppState.sdk) return ppState.sdk;

    const bar = ppBar();
    const clientId = bar && bar.dataset.paypalClientId;
    if (!clientId) return null;

    ppState.sdk = new Promise((resolve, reject) => {
      if (typeof paypal !== 'undefined' && paypal.Messages) {
        resolve();
        return;
      }
      const script = document.createElement('script');
      script.src = 'https://www.paypal.com/sdk/js?client-id=' + encodeURIComponent(clientId) +
        '&currency=USD&components=messages&locale=en_US';
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });

    // 加载失败保持静默：分期条继续隐藏，不影响价格与加购
    ppState.sdk.catch(() => { ppState.sdk = null; });
    return ppState.sdk;
  }

  function ppRender() {
    const bar = ppBar();
    if (!bar || ppState.amount === null || typeof paypal === 'undefined') return;

    // Messages 只能渲染进空容器，换金额或换字号都要重建 slot。
    // slot 不能带 data-pp-message：SDK 会自动扫描并渲染带该属性的元素，与这里的显式 render 撞车，
    // 旧 slot 被替换后 SDK 报 paypal_messages_not_in_document 并抛 TypeError
    const slot = document.createElement('div');
    slot.className = 'modal-pp-message';
    const current = bar.querySelector('.modal-pp-message');
    if (current) {
      bar.replaceChild(slot, current);
    } else {
      bar.appendChild(slot);
    }

    ppState.size = ppMessageSize();
    const rendered = paypal.Messages({
      amount: ppState.amount,
      currency: 'USD',
      buyerCountry: 'US',
      style: {
        layout: 'text',
        logo: { type: 'primary' },
        text: { color: 'white', size: ppState.size }
      }
    }).render(slot);

    // 等 message 真正渲染出来再显形，否则会先闪一条只有分割线的空条
    if (rendered && typeof rendered.then === 'function') {
      rendered.then(() => { bar.hidden = false; }, () => {});
    } else {
      bar.hidden = false;
    }
  }

  function ppSetAmount(amountDollars) {
    const bar = ppBar();
    if (!bar) return;

    ppState.amount = amountDollars;
    if (amountDollars === null) {
      bar.hidden = true;
      return;
    }
    if (typeof paypal !== 'undefined' && paypal.Messages) ppRender();
  }

  // 弹窗首次展开时才拉 SDK：首屏不为一条文案付出一次 100KB+ 的请求
  function ppActivate() {
    const sdk = ppLoadSdk();
    if (sdk) sdk.then(ppRender, () => {});
  }

  // 跨断点时字号换一档，重渲一次
  function ppWatchBreakpoint() {
    const mq = window.matchMedia('(max-width: 1023.98px)');
    const onChange = () => {
      if (ppState.size !== null && ppState.size !== ppMessageSize()) ppRender();
    };
    if (mq.addEventListener) {
      mq.addEventListener('change', onChange);
    } else {
      mq.addListener(onChange);
    }
  }

  /**
   * 移动端底部 footer 是 absolute 的，高度随 PayPal 文案行数与字体加载变化。
   * 实测后写进 --yd-cta-footer-h，内容区底部留白跟着走，避免盖住最后一段内容。
   */
  function initFooterSpacing() {
    const footer = document.querySelector('.modal-right-footer');
    const content = document.querySelector('.cta-modal-content');
    if (!footer || !content || typeof ResizeObserver === 'undefined') return;

    const apply = () => {
      content.style.setProperty('--yd-cta-footer-h', footer.offsetHeight + 'px');
    };
    new ResizeObserver(apply).observe(footer);
    apply();
  }

  function formatMoney(cents) {
    // 简化版（仅支持小数点 2 位）。如需多币种格式化，可读 Shopify.currency 设置
    const dollars = (cents / 100).toFixed(2);
    return '$' + dollars;
  }

  function initVariantCards() {
    const cards = Array.from(document.querySelectorAll('.finish-card[data-variant-id]'));
    if (cards.length === 0) return;

    const priceEl = document.querySelector('.modal-price[data-total-price]');
    const comparePriceEl = document.querySelector('.modal-compare-price');
    const variantNameEl = document.querySelector('[data-variant-name]');
    const buyBtn = document.querySelector('.modal-order-btn[data-add-to-cart]');

    function updateTotalsAndState() {
      let totalCents = 0;
      let anySelected = false;
      const selectedNames = [];

      cards.forEach(card => {
        const selected = card.classList.contains('finish-card--selected');
        if (selected) {
          totalCents += parseInt(card.dataset.variantPriceCents || '0', 10);
          anySelected = true;
          selectedNames.push(card.dataset.variantTitle || '');
        }
      });

      // 价格下方的所选 SKU 名（Figma 4331:365）
      if (variantNameEl) variantNameEl.textContent = selectedNames.filter(Boolean).join(' + ');

      if (priceEl) {
        priceEl.textContent = formatMoney(totalCents);
        priceEl.style.visibility = anySelected ? 'visible' : 'hidden';
      }
      if (comparePriceEl) comparePriceEl.style.display = 'none';
      if (buyBtn) {
        buyBtn.disabled = !anySelected;
      }
      // 分期文案跟随所选 variant 的合计金额
      ppSetAmount(anySelected ? (totalCents / 100).toFixed(2) : null);
    }

    function selectOnly(target) {
      cards.forEach(c => {
        const on = c === target;
        c.classList.toggle('finish-card--selected', on);
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      updateTotalsAndState();
      // 左侧轮播切到该 variant 的图片集
      if (galleryApi && target) galleryApi.setVariant(target.dataset.variantId);
    }

    cards.forEach((card, index) => {
      card.setAttribute('role', 'radio');
      card.setAttribute('tabindex', '0');

      // 默认选中第一个 variant
      const initialSelected = index === 0;
      card.classList.toggle('finish-card--selected', initialSelected);
      card.setAttribute('aria-pressed', initialSelected ? 'true' : 'false');

      card.addEventListener('click', () => selectOnly(card));
      card.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectOnly(card);
        }
      });
    });

    updateTotalsAndState();
    // 初始按默认选中的 variant 过滤轮播图片
    const initialCard = cards.find(c => c.classList.contains('finish-card--selected'));
    if (galleryApi && initialCard) galleryApi.setVariant(initialCard.dataset.variantId);
  }

  /**
   * 弹窗内 Toast 提示
   */
  function showToast(message) {
    if (typeof gsap === 'undefined') return;

    // 移除已有 toast
    var existing = document.querySelector('.cta-toast');
    if (existing) {
      gsap.killTweensOf(existing);
      existing.remove();
    }

    var toast = document.createElement('div');
    toast.className = 'cta-toast';
    toast.textContent = message;
    document.body.appendChild(toast);

    gsap.fromTo(toast,
      { autoAlpha: 0, y: -10 },
      {
        autoAlpha: 1, y: 0, duration: 0.3, ease: 'power2.out',
        onComplete: function() {
          gsap.to(toast, {
            autoAlpha: 0, y: -10, duration: 0.3, ease: 'power2.in',
            delay: 3,
            onComplete: function() { toast.remove(); }
          });
        }
      }
    );
  }

  /**
   * 初始化加购物车
   * 点击 modal-order-btn → POST /cart/add.js → 关闭弹窗 → 派发 cart:update 事件
   */
  /**
   * 加购物车：收集所有 .finish-card--selected，每个 quantity:1 批量提交到 /cart/add.js（数量在购物车页调整）
   */
  function initAddToCart() {
    const buyBtn = document.querySelector('.modal-order-btn[data-add-to-cart]');
    if (!buyBtn) return;

    let isSubmitting = false;

    buyBtn.addEventListener('click', async (e) => {
      e.preventDefault();
      if (isSubmitting) return;
      if (buyBtn.disabled) return;

      // 收集所有选中的 variant，每个固定加购 1 件（数量在购物车页调整）
      const items = [];
      document.querySelectorAll('.finish-card[data-variant-id].finish-card--selected').forEach(card => {
        const variantId = card.dataset.variantId;
        if (variantId) {
          items.push({ id: parseInt(variantId, 10), quantity: 1 });
        }
      });

      if (items.length === 0) {
        showToast('Please select at least one item');
        return;
      }

      isSubmitting = true;
      const originalText = buyBtn.textContent;
      buyBtn.textContent = 'Adding...';
      buyBtn.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.message || 'Failed to add to cart');
        }

        // 加购成功 — 直接跳转到购物车页
        window.location.href = '/cart';
        return;

      } catch (error) {
        console.error('Add to cart failed:', error);
        showToast(error.message || 'Failed to add to cart');
      } finally {
        isSubmitting = false;
        buyBtn.disabled = false;
        buyBtn.textContent = originalText;
      }
    });
  }

  /**
   * 初始化 FAQ 手风琴
   */
  function initAccordion() {
    const faqItems = document.querySelectorAll('.faq-item');
    faqItems.forEach(item => {
      const trigger = item.querySelector('.faq-trigger');
      trigger?.addEventListener('click', () => {
        item.classList.toggle('expanded');
      });
    });
  }

  /**
   * 主初始化函数
   */
  function init() {
    const cta = document.getElementById('global-cta');
    if (!cta) return;

    initCTATextRotation();
    initCTAModal();
    initGallery();
    initScrollFade();
    initVariantCards();
    initAddToCart();
    initAccordion();
    ppWatchBreakpoint();
    initFooterSpacing();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
